import account from './moduleAccount'
export default account
